import { addAction, logToDd } from "./ddLog";

export class Logger {
  static logger = console;

  static LOG_LEVELS = {
    TRACE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
  };
  static levelOrder = {
    trace: Logger.LOG_LEVELS.TRACE,
    debug: Logger.LOG_LEVELS.DEBUG,
    info: Logger.LOG_LEVELS.INFO,
    warn: Logger.LOG_LEVELS.WARN,
    error: Logger.LOG_LEVELS.ERROR,
  };

  static currentLogLevel = Logger.LOG_LEVELS.INFO;
  static datadogLogLevel = Logger.LOG_LEVELS.INFO;
  static testApplicationLogs = Logger.LOG_LEVELS.INFO;

  static setLogLevel(level: number) {
    if (Object.values(Logger.LOG_LEVELS).includes(level)) {
      Logger.currentLogLevel = level;
    } else {
      throw new Error(`Invalid log level: ${level}`);
    }
  }

  static log(
    level: "trace" | "debug" | "info" | "warn" | "error",
    context: string,
    message: string,
    data?: any,
    event?: boolean
  ) {
    if (Logger.levelOrder[level] < Logger.currentLogLevel) {
    } else {
      const colors = {
        trace: "gray",
        debug: "white",
        info: "lightgreen",
        warn: "orange",
        error: "red",
      };
      const logData = {};
      const color = colors[level] || "black";
      const logMessage = `%c[${context}]: ${message}`;
      if (data) {
        const fullLogData = {
          ...data,
          ...logData,
        };
        Logger.logger[level](logMessage, `color: ${color}`, fullLogData);
      } else {
        Logger.logger[level](logMessage, `color: ${color}`);
      }
    }
    if (Logger.levelOrder[level] < Logger.datadogLogLevel) {
    } else {
      const logData = {};
      const fullLogData = {
        uavId: data?.uavId || "no-uav",
        ...data,
        ...logData,
      };
      logToDd(message, context, fullLogData, fullLogData?.uavId || "no-uav");
    }

    if (event) {
      Logger.eventInfo(context, {
        message,
        ...data,
      });
    }
  }

  static trace(context: string, message: string, data?: any) {
    Logger.log("trace", context, message, data);
  }

  static debug(context: string, message: string, data?: any) {
    Logger.log("debug", context, message, data);
  }

  static info(context: string, message: string, data?: any) {
    Logger.log("info", context, message, data);
  }

  static eventInfo(context: string, message: string, data: any = {}) {
    addAction(context, {
      message,
      ...data,
    });
  }

  static warn(context: string, message: string, data?: any) {
    Logger.log("warn", context, message, data);
  }

  static error(context: string, error: string | Error | unknown, data?: any) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : typeof error === "string"
        ? error
        : "Unknown error";
    Logger.log("error", context, errorMessage, data);
    if (error instanceof Error) {
      Logger.logger.error(error.stack);
    }
  }
}
